import SingleSelectedProperty from "../../../../common/state/modules/singleSelectedProperty";
import GloballySelected from "../../../../common/state/modules/globallySelected";
import DetailView from "../../../../common/models/detailView/detailView";
import DetailViewContentElement from "../../../../common/models/detailView/elements/detailViewContentElement";
import ObjectModel from "../../../../common/models/objectModel";

export default class Selected extends GloballySelected {
  static detailView = new SingleSelectedProperty('detailView', () => DetailView);
  static detailViewContentElement = new SingleSelectedProperty('detailViewContentElement', () => DetailViewContentElement);
  static objectModel = new SingleSelectedProperty("objectModel", () => ObjectModel)
}